import { type Dispatch } from '@reduxjs/toolkit'

import { authSlice } from '../../../authSlice'

export const resetForgotPasswordState = (dispatch: Dispatch) => {
  dispatch(authSlice.actions.setForgotPasswordStep('request'))
  dispatch(authSlice.actions.resetForgotPasswordFields())
}
